import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useCallback, useMemo, useContext } from 'react';

const ActionsContext = /*#__PURE__*/createContext({
  wrapper: null,
  setWrapperNode: wrapper => {
    console.log('setWrapperNode not set', wrapper.id);
  },
  setWrapper: () => {
    console.log('setWrapper not set');
  }
});
function ActionsProvider(_ref) {
  let {
    children
  } = _ref;
  const [wrapper, setWrapper] = useState(null);
  const setWrapperNode = useCallback(wrapper => {
    const parseActions = wrapper => {
      try {
        const dataActions = wrapper.getAttribute('data-actions');
        const actions = dataActions ? JSON.parse(dataActions) : [];
        // console.log('setWrapperNode.parseActions', actions);
        return actions;
      } catch (error) {
        console.log('setWrapperNode.parseActions.error', error);
        return [];
      }
    };
    const actions = parseActions(wrapper);
    if (actions.length > 0) {
      const newWrapper = {
        node: wrapper,
        id: wrapper.id,
        actions
      };
      // console.log('setWrapper', newWrapper);
      setWrapper(newWrapper);
    }
  }, [setWrapper]);
  const value = useMemo(() => {
    return {
      wrapper,
      setWrapperNode,
      setWrapper
    };
  }, [wrapper, setWrapperNode, setWrapper]);
  return jsx(ActionsContext.Provider, {
    value: value,
    children: children
  });
}
function useActions() {
  const wrapper = useContext(ActionsContext);
  return wrapper;
}

export { ActionsContext, ActionsProvider, useActions };
//# sourceMappingURL=useActions.js.map
